import React, { useState, memo, useEffect } from "react";
import { Features } from "@azure/communication-calling";
import { useLocation } from "react-router-dom";
import HostName from "../Sub_components/HostName";
import Loader from "../Sub_components/Loader";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import ClassAppointmentExitPopup from "../PopupModal/EndCallModal";
import Dropdown from "react-bootstrap/Dropdown";
import RecordingStates from "../Common/Constants";
import { usePropsFor, CameraButton, MicrophoneButton, } from "@azure/communication-react";
import Avtar from "../Sub_components/Avtar";
import axios from "axios";
import DigitalWatch from "../Sub_components/DigitalWatch"
import { BackgroundBlurEffect } from '@azure/communication-calling-effects';
import DataChanneling from "../GeneralFunctions/DataChanneling";
import EndLiveStream from "../GeneralFunctions/EndLiveStream";
import Permission from "../GeneralFunctions/Permission";
import { getBrowserPermissionSteps } from "../utils/getBrowserPermissionSteps";
function Navbar({
  onSelect,
  call,
  setLayout,
  hostBeRightBack,
  layout,
  isActive,
  isHostNotJoined,
  chatColor,
  createLocalVideoStream,
  setIsCam,
  isInstructorModeRef,
  vertualFocusedContent,
  countRef,
  setExpendVideoTile
}) {
  const { endCall } = EndLiveStream();
  const { checkPermissions } = Permission();

  const {
    role,
    roomId,
    __appConfirmUniqueID,
    serverCallId,
    __merchantId,
    __userId,
    appInsightTrack,
    eventType,
    recordingId,
    setRecordingId,
    recordingAction,
    toggleStates,
    classesName,
    photoHostUrl,
    userNameHost,
    loaderAnimation,
    setInformationContent,
    setShowInformationStrip,
    setRecordingAction,
    recodingIColor,
    setRecodingIColor,
    apiUrlPost,
    isAndroidTablet,
    isMobile,
    setServerCallId,
    setToggleStates,
    setIsReciveingOrShareingScreenShare,
    setIsMic,
    isMic,
    microphonePermission,
    cameraPermission,    
  } = useLiveStreamAppContext();
  const { sendActionToAttendee } = DataChanneling();
  const cameraProps = usePropsFor(CameraButton);
  const microphoneProps = usePropsFor(MicrophoneButton);
  const [exitModalShow, setExitModalShow] = useState(false);
  const [screenSharingNotification, setScreenSharingNotification] = useState(null);
  const [screenShare, setScreenShare] = useState(false);
  const [videoEffectsFeatureApi, setVideoEffectsFeatureApi] = useState();
  const [showGalleryMobile, setShowGalleryMobile] = useState(false);
  const locationPath = useLocation();
  const [isCameraEnabled, setIsCameraEnabled] = useState(false);
  const [isMicrophoneEnabled, setIsMicrophoneEnabled] = useState(false);
  // check for the android to disble the screen Share Icon
  const platform = navigator.userAgent.indexOf("VagaroAndroidPhone") > -1 || navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("VagaroAndroidTablet") > -1
    useEffect(() => {
      // Check initial permissions
      checkPermissions();
      // Set up interval to check for permission changes
      // (Note: There's no direct event for permission changes, so we poll)
      const interval = setInterval(checkPermissions, 1000);
  
      return () => clearInterval(interval);
    }, []);
  useEffect(() => {
    if (microphonePermission !== "granted") {
      if (!call?.isMuted) {
        call?.mute();
      }
      setIsMic(false);
    }

    if (cameraPermission !== "granted") {
      let videoStream = call.localVideoStreams.find((stream) => {
        return stream.mediaStreamType === "Video";
      });
      if (call.isLocalVideoStarted) {
        call.stopVideo(videoStream);
      }
      setIsCam(false);
    }
  }, [cameraPermission, microphonePermission]);    
  useEffect(() => {
    const blurEffect = async () => {
      try {
        if (call) {
          const videoEffectsFeatureApi = await call?.localVideoStreams
            .find((stream) => stream.mediaStreamType === "Video")
            ?.feature(Features.VideoEffects);

          setVideoEffectsFeatureApi(videoEffectsFeatureApi);
          if (toggleStates.blurBackground && videoEffectsFeatureApi) {
            const effect = new BackgroundBlurEffect();
            const isSupported = videoEffectsFeatureApi?.isSupported(effect);
            if (!isSupported) {
              console.error("Background blur is not supported on this device or browser.");
              return;
            }
            videoEffectsFeatureApi?.startEffects(effect);
          } else {
            videoEffectsFeatureApi?.stopEffects();
          }
        }
      } catch (error) {
        console.error("Error while Applying Blur Background Effect");
      }
    }
    blurEffect();
  }, [call, call?.isLocalVideoStarted, toggleStates.blurBackground]);

  useEffect(() => {
    if (isMic) {
      if (call?.isMuted) call?.unmute();
    } else {
      if (!call?.isMuted) call?.mute();
    }
  }, [isMic])

  const handleBlurEffect = async () => {
    try {
      if (videoEffectsFeatureApi?.activeEffects?.length === 0) {
        setToggleStates((prev) => ({
          ...prev,
          blurBackground: true,
        }))
      } else {
        setToggleStates((prev) => ({
          ...prev,
          blurBackground: false,
        }))
      }
    } catch (error) {
      console.error("Error toggling background effect:", error);
    }
  };

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId,
  };

  const layoutOptions = eventType === 1 ? {
    "Gallery View": "default",
    "Presenter Window": "floatingLocalVideo",
  } : {
    "Gallery View": "default",
    "Presenter Window": "floatingLocalVideo",
    Speaker: "speaker",
  };

  const EndCallButtonTextHead = () => {
    if (role === "Presenter") {
      return eventType === 1 ? "End Appointment" : "End Class";
    }
    if (role === "Attendee") {
      return eventType === 1 ? "Leave Appointment" : "Leave Class";
    }
    return "";
  };

  const getExitMessage = () => {
    if (role === "Presenter") {
      return eventType === 1
        ? "Are you sure you want to end the Appointment? This will end your live stream and attendee will be logged out."
        : "Are you sure you want to end the class? This will end your live stream and all attendees will be logged out.";
    }

    if (role === "Attendee") {
      return eventType === 1
        ? "Are you sure you want to leave the appointment?"
        : "Are you sure you want to leave the class?";
    }
    return "Are you sure you want to exit the meeting?";
  };

  function handleEndCall() {
    setExitModalShow(false);
    endCall();
    return;
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setScreenSharingNotification(null);
    }, 5000);

    // Cleanup function to clear the timeout if the component unmounts or if screenSharingNotification changes
    return () => clearTimeout(timeoutId);
  }, [screenSharingNotification]);

  useEffect(() => {
    if (screenShare) {
      if (call?.isScreenSharingOn) {
        setScreenSharingNotification({
          message: "Screen sharing started.",
        });
      } else {
        setScreenSharingNotification({
          message: "Screen sharing stopped.",
        });
      }
    }
  }, [call?.isScreenSharingOn, screenShare]);

  useEffect(() => {
    if (call?.isScreenSharingOn && !toggleStates["EnableScreenShare"]) {
      call.stopScreenSharing()
    }
  }, [toggleStates["EnableScreenShare"]])

  useEffect(() => {
    if ((role === "Attendee" && isInstructorModeRef.current) || (role === "Attendee" && !toggleStates["EnableVideo"])) {
      setToggleStates((prev) => ({ ...prev, blurBackground: false })); // Set blurBackground to false when video is disabled or isInstructorMode is true and t.blurBackground
    }
  }, [toggleStates["EnableVideo"]])

  const handleScreenShare = async () => {
    try {
      setScreenShare(true);
      if (call?.isScreenSharingOn) {
        setIsReciveingOrShareingScreenShare(false);
        await call.stopScreenSharing();
      } else {
        await call.startScreenSharing();
        setIsReciveingOrShareingScreenShare(true);
      }
    } catch (error) {
      console.error("Error starting/stopping screen share:", error);
      appInsightTrack(__merchantId, __userId, "Start/Stop screen share Error", "", error);
    }
  };

  // ---- Function to handle Recording Start/Pause/Resume ---- //
  const handleRecordingClassApp = async () => {
    let sserverCallId = null;
    sserverCallId = serverCallId;

    if (!sserverCallId) {
      let x = { ...call };
      sserverCallId = await x._info.getServerCallId();
      setServerCallId(sserverCallId);
    }

    if (!sserverCallId) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'alert',
        message: "Something went wrong with Start Recording. Please try again.",
      });
      return;
    }

    if (recordingAction === 4) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'alert',
        message: "Recording for this livestream is already done.",
      });
      return;
    }

    let recordingActionToPass;
    let newColor;
    if (recordingAction === 0) {
      recordingActionToPass = RecordingStates.START_RECORDING;
    }
    else if (recordingAction === 1) {
      recordingActionToPass = RecordingStates.PAUSE_RECORDING;
    } else if (recordingAction === 2) {
      recordingActionToPass = RecordingStates.RESUME_RECORDING;
    } else if (recordingAction === 3) {
      recordingActionToPass = RecordingStates.PAUSE_RECORDING;
    }

    let recordingApiCall = document.getElementById("recordingIcon");
    let recordingApiCallMobile = document.getElementById("recordingIconMobile");

    recordingApiCall !== null && !recordingApiCall?.classList.contains("divDisabled") && recordingApiCall?.classList.add("divDisabled");
    recordingApiCallMobile !== null && !recordingApiCallMobile?.classList.contains("divDisabled") && recordingApiCallMobile?.classList.add("divDisabled");

    const payload = {
      appConfirmUniqueId: __appConfirmUniqueID,
      roomId: roomId,
      serverCallId: sserverCallId,
      recordingId: recordingId || "",
      recordingAction: recordingActionToPass,
    };
    try {
      const response = await axios.post(
        `${apiUrlPost}managerecording`,
        payload, { headers }
      );
      if (response.data.data.recordingId) {
        setRecordingId(response.data.data.recordingId);
      }
    } catch (error) {
      console.error("An error occurred", error);
      if (error.status === 400 || error.status === 500) {
        console.error(error.message);
        setShowInformationStrip(true);
        setInformationContent({
          type: 'alert',
          message: error.message,
        });
      }
      appInsightTrack(__merchantId, __userId, "API Error managerecording", "", error);
      recordingApiCall?.classList.contains("divDisabled") && recordingApiCall?.classList.remove("divDisabled");
      recordingApiCallMobile?.classList.contains("divDisabled") && recordingApiCallMobile?.classList.remove("divDisabled");
      return;
    }
    setRecordingAction(recordingActionToPass)
    if (recordingActionToPass === 1 || recordingActionToPass === 3) {
      setToggleStates((prevStates) => ({
        ...prevStates,
        StartRecording: true,
      }));
      newColor = "red";
      sendActionToAttendee("ALL", "ENABLE_START_RECORDING_FOR_ALL");
    } else {
      setToggleStates((prevStates) => ({
        ...prevStates,
        StartRecording: false,
      }));
      newColor = "#fff";
      sendActionToAttendee("ALL", "DISABLE_START_RECORDING_FOR_ALL");
    }
    setRecodingIColor(newColor);
    recordingApiCall?.classList.contains("divDisabled") && recordingApiCall?.classList.remove("divDisabled");
    recordingApiCallMobile?.classList.contains("divDisabled") && recordingApiCallMobile?.classList.remove("divDisabled");
  };

  useEffect(() => {
    if (
      toggleStates["StartRecording"] &&
      locationPath.pathname === "/livestream/meeting" &&
      serverCallId &&
      recordingAction === 0 &&
      role === "Presenter"
    ) {
      handleRecordingClassApp();
    } else if (toggleStates["StartRecording"] && recordingAction === 0 && role === "Presenter") {
      let recordingApiCall = document.getElementById("recordingIcon");
      let recordingApiCallMobile = document.getElementById("recordingIconMobile");
      recordingApiCall !== null && !recordingApiCall?.classList.contains("divDisabled") && recordingApiCall?.classList.add("divDisabled");
      recordingApiCallMobile !== null && !recordingApiCallMobile?.classList.contains("divDisabled") && recordingApiCallMobile?.classList.add("divDisabled");
    }
  }, [toggleStates["StartRecording"], locationPath.pathname, serverCallId]);

  let videoGalleryWrapperClassAddAndRemove = (value) => {
    let x = document.getElementsByClassName("VideoGallery-wrapper")
    if (value === "floatingLocalVideo" || value === "speaker") {
      if (x[0]) {
        x[0].classList.add("backgroundgray")
      }
    } else {
      if (x[0]) {
        x[0].classList.remove("backgroundgray")
      }
    }
  }

  

  return (
    <>
      {loaderAnimation && <Loader />}
      <div className={`player-action-bar fixed-player ${hostBeRightBack ? 'btn-left-icon' : ''}`}>
        <HostName />
        {
          <>
            <div className="controls-btn tooltip attendee-menu three-dot-menu mobile-dropdown-menu hide-on-mobile presentationIcon">
              <Dropdown>
                <span id="spanShareScreen" className="tooltiptext">
                  Gallery View
                </span>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className="btn btn-3dot-icon"
                >
                  <div className="three-dot-menu">
                    <i className="fa-light fa-gallery-thumbnails icon"></i>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {Object.entries(layoutOptions).map(([key, value]) => (
                    <Dropdown.Item
                      key={key}
                      href="#"
                      active={(layout === value && vertualFocusedContent) || (layout === value && countRef.current > 0)}
                      onClick={(e) => {
                        e.preventDefault();
                        if (value !== "focusedContent") {
                          setLayout(value);
                          videoGalleryWrapperClassAddAndRemove(value)
                          setExpendVideoTile(false);
                        } else {
                          setLayout(value);
                          countRef.current = countRef.current + 1;
                        }
                      }}
                    >
                      {key}
                    </Dropdown.Item>

                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {!platform && !isMobile && !isAndroidTablet && <div
              className={`controls-btn tooltip not-sharing screenShareIcon ${toggleStates["EnableScreenShare"]
                ? ""
                : role === "Presenter"
                  ? ""
                  : "divDisabled"
                }`}
              onClick={handleScreenShare}
              id="screenShareIcon"
            >
              <svg fill="currentColor" className="icon ___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0 screenShareIcon" aria-hidden="true" width="35" height="35" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false">
                <path d="M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm6 10a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5Z" fill={`${call?.isScreenSharingOn ? 'currentColor' : toggleStates["EnableScreenShare"] ? '#fff' : ""}`}></path>
              </svg>
              <span id="spanShareScreen" className="tooltiptext">
                {call?.isScreenSharingOn
                  ? "Stop Screen Share"
                  : "Start Screen Share"}
              </span>
            </div>}

            {role === "Presenter" && (
              <div
                id="recordingIcon"
                className={`controls-btn tooltip recording-start-stop hide-on-mobile ${recordingAction === 4 && "recordingStateChecking"
                  }`}
                onClick={() => { handleRecordingClassApp(); }}
              >
                <i
                  className={`icon font-awesome-light-pro va-record-vinyl`}
                  style={{ color: recodingIColor }}
                ></i>
                <span className="tooltiptext">{recodingIColor === "#fff" ? "Record Start" : "Recording"}</span>
              </div>
            )}
            {!(isMobile || isAndroidTablet) && (
              <div
                className={`controls-btn tooltip not-sharing hide-on-mobile ${!call?.isLocalVideoStarted ? "divDisabled" : ""}`}
                onClick={() => handleBlurEffect()}
                id="BlurIcon"
              >
                {toggleStates.blurBackground
                  ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.71505 23.8969L4.53726 25.5M27.3894 13.8304L23.1259 15.9813M27.2909 17.9831L20.9417 21.1863M27.4303 22.4918L24.2469 24.0978M10.2286 18.4664L4.82822 21.1909M27.5 9.70265L20.1462 13.4851M25.6435 6.5L4.66035 17.0859M15.9577 6.75188L4.5 12.5323M7.71505 6.68957L4.53726 8.29276" stroke="white" strokeOpacity="1" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M18.6428 17C18.6428 18.6875 17.2187 20 15.5 20C13.7321 20 12.3571 18.6875 12.3571 17C12.3571 15.3594 13.7321 14 15.5 14C17.2187 14 18.6428 15.3594 18.6428 17ZM15.5 15.5C14.616 15.5 13.9286 16.2031 13.9286 17C13.9286 17.8438 14.616 18.5 15.5 18.5C16.3348 18.5 17.0714 17.8438 17.0714 17C17.0714 16.2031 16.3348 15.5 15.5 15.5ZM17.4643 21.5C19.3794 21.5 21 23.0469 21 24.8749C21 25.5312 20.4599 26 19.8215 26H11.1786C10.4911 26 10 25.5312 10 24.8749C10 23.0469 11.5714 21.5 13.5357 21.5H17.4643ZM13.5357 23C12.5536 23 11.7679 23.6561 11.5714 24.5H19.3794C19.1831 23.6561 18.3973 23 17.4643 23H13.5357Z" fill="white" fillOpacity="1" />
                  </svg>
                  : <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.71505 23.8969L4.53726 25.5M27.3894 13.8304L23.1259 15.9813M27.2909 17.9831L20.9417 21.1863M27.4303 22.4918L24.2469 24.0978M10.2286 18.4664L4.82822 21.1909M27.5 9.70265L20.1462 13.4851M25.6435 6.5L4.66035 17.0859M15.9577 6.75188L4.5 12.5323M7.71505 6.68957L4.53726 8.29276" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M18.6428 17C18.6428 18.6875 17.2187 20 15.5 20C13.7321 20 12.3571 18.6875 12.3571 17C12.3571 15.3594 13.7321 14 15.5 14C17.2187 14 18.6428 15.3594 18.6428 17ZM15.5 15.5C14.616 15.5 13.9286 16.2031 13.9286 17C13.9286 17.8438 14.616 18.5 15.5 18.5C16.3348 18.5 17.0714 17.8438 17.0714 17C17.0714 16.2031 16.3348 15.5 15.5 15.5ZM17.4643 21.5C19.3794 21.5 21 23.0469 21 24.8749C21 25.5312 20.4599 26 19.8215 26H11.1786C10.4911 26 10 25.5312 10 24.8749C10 23.0469 11.5714 21.5 13.5357 21.5H17.4643ZM13.5357 23C12.5536 23 11.7679 23.6561 11.5714 24.5H19.3794C19.1831 23.6561 18.3973 23 17.4643 23H13.5357Z" fill="white" fillOpacity="0.6" />
                  </svg>}
                <span id="spanShareScreen" className="tooltiptext">
                  Blur Background
                </span>
              </div>
            )}
              <div
                className={`m-right16 cameraIcon ${
                  (cameraPermission !== "granted" ||
                 ( role === "Attendee" &&  !toggleStates["EnableVideo"])) &&
                  "divDisabled"
                }`}
                style={{ display: cameraPermission === "granted" ? "block" : "none" }}
                id={"camIconDiv"}
              >
                {cameraProps && (
                  <CameraButton
                    {...cameraProps}
                    onToggleCamera={async (e) => {
                      try {
                        let videoStream = call.localVideoStreams.find(
                          (stream) => {
                            return stream.mediaStreamType === "Video";
                          }
                        );
                        let camPreviewElement =
                          document.getElementById("camera_preview");
                        if (call.isLocalVideoStarted) {
                          call.stopVideo(videoStream);
                          setToggleStates((prev) => ({
                            ...prev,
                            blurBackground: false,
                            mirrorMyVideo: false,
                            isSelfCam: false,
                          }));
                          let blurBackground =
                            document.getElementById("blurBackgrounddiv");
                          !blurBackground?.classList.contains("divDisabled") &&
                            blurBackground?.classList.add("divDisabled");
                          let mirrorMyVideo =
                            document.getElementById("mirrorMyVideodiv");
                          !mirrorMyVideo?.classList.contains("divDisabled") &&
                            mirrorMyVideo?.classList.add("divDisabled");
                          let blurIcon = document.getElementById("BlurIcon");
                          !blurIcon?.classList.contains("divDisabled") &&
                            blurIcon?.classList.add("divDisabled");
                          if (camPreviewElement) {
                            camPreviewElement.style.display = "none";
                          }
                        } else {
                          setIsCam(true);
                          // Revoking camera permission mid-call kills the track but can leave
                          // a dead LocalVideoStream registered on the call - clear it first,
                          // otherwise startVideo fails with code=500 subCode=43002
                          if (videoStream) {
                            try {
                              await call.stopVideo(videoStream);
                            } catch (stopError) {
                              console.warn("Failed to remove stale video stream:", stopError);
                            }
                          }
                          let locaStream = await createLocalVideoStream(true);
                          if (locaStream) {
                            try {
                              await call.startVideo(locaStream);
                            } catch (startError) {
                              // subCode 43002 is a transient runtime failure after permission
                              // re-grant - Microsoft recommends retrying with a fresh stream
                              appInsightTrack(__merchantId, __userId, "startVideo failed, retrying", "", startError);
                              await new Promise((resolve) => setTimeout(resolve, 500));
                              locaStream = await createLocalVideoStream(true);
                              locaStream && (await call.startVideo(locaStream));
                            }
                          }
                          setToggleStates((prev) => ({
                            ...prev,
                            isSelfCam: true,
                          }));
                          let blurBackground =
                            document.getElementById("blurBackgrounddiv");
                          blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.remove("divDisabled");
                          let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
                          mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.remove("divDisabled");
                          let blurIcon = document.getElementById("BlurIcon");
                          blurIcon?.classList.contains("divDisabled") &&
                            blurIcon?.classList.remove("divDisabled");
                          if (camPreviewElement) {
                            camPreviewElement.style.display = "block";
                          }
                        }
                      } catch (e) {
                        console.error(e);
                        appInsightTrack(
                          __merchantId,
                          __userId,
                          "Error onToggleCamera",
                          "",
                          e
                        );
                      }
                    }}
                    disabled={
                      (role === "Attendee" && isInstructorModeRef.current) ||
                      cameraPermission !== "granted"
                    }
                    id={"camIcon"}
                  />
                )}
              </div>

            <div style={{ cursor: 'pointer' }} onClick={() => setIsCameraEnabled(true)} className={`m-right16 cameraIcon  controls-btn-relative`}>
            {cameraPermission !== "granted" && (
              <div
                className={`controls-btn tooltip not-sharing ${
                  !call?.isLocalVideoStarted ? "divDisabled" : ""
                }`}
              >
                <span>
                  <span  className="tooltiptext">
                    Allow Vagaro to Access Camera
                  </span>
                  <i
                      className="icon font-awesome-solid-pro va-exclamation-triangle mb-icon icon-warning-bell"
                    style={{ color: "orange", marginTop: "8px", fontSize:"15px" }}
                  />
                    <i className="fas fa-video-slash"
                  style={{ color: "#666666", marginTop: "8px" , fontSize:"24px"}}
                  ></i>

                </span>
              </div>
            )}
</div>
            {microphonePermission === "granted" && (
              <div
                className={`m-right16 ${
                  (microphonePermission !== "granted" ||
                  (role === "Attendee" &&   !toggleStates["EnableMic"])) &&
                  "divDisabled"
                }`}
                id={"micIconDiv"}
              >
                {microphoneProps && (
                  <MicrophoneButton
                    {...microphoneProps}
                    onToggleMicrophone={(e) => {
                      if (isMic) {
                        setIsMic(false);
                        setToggleStates((prev) => ({
                          ...prev,
                          removeBackgroundNoise: false,
                        }));
                        let removeBackgroundNoise = document.getElementById(
                          "removeBackgroundNoisediv"
                        );
                        !removeBackgroundNoise?.classList.contains(
                          "divDisabled"
                        ) &&
                          removeBackgroundNoise?.classList.add("divDisabled");
                      } else {
                        setIsMic(true);
                        let removeBackgroundNoise = document.getElementById(
                          "removeBackgroundNoisediv"
                        );
                        removeBackgroundNoise?.classList.contains("divDisabled") && removeBackgroundNoise?.classList.remove("divDisabled");
                        if (eventType === 1) {
                          let shareDeviceAudio = document.getElementById(
                            "shareDeviceAudiodiv"
                          );
                          shareDeviceAudio?.classList.contains("divDisabled") &&
                            shareDeviceAudio?.classList.remove("divDisabled");
                        }
                      }
                    }}
                    checked={isMic}
                    disabled={
                      hostBeRightBack ||
                      isHostNotJoined ||
                      microphonePermission !== "granted" ||
                      (role === "Attendee" && isInstructorModeRef.current)
                    }
                    id={"micIcon"}
                  />
                )}
              </div>
            )}
            <div style={{ cursor: 'pointer' }} onClick={() => setIsMicrophoneEnabled(true)} className={`controls-btn-relative `}>
            {microphonePermission !== "granted" && (
              <div
                className={`controls-btn tooltip not-sharing  ${
                  !call?.isLocalVideoStarted ? "divDisabled" : ""
                }`}
              >
                <span>
                  <span id="spanShareScreen" className="tooltiptext">
                    Allow Vagaro to Access Microphone
                  </span>
                  <i
                      className="icon font-awesome-solid-pro va-exclamation-triangle mb-icon icon-warning-bell"
                    style={{ color: "orange", marginTop: "8px", fontSize:'15px' }}
                  />
                  <i className="fas fa-microphone-slash"
                  style={{ color: "#666666", marginTop: "8px", fontSize:'24px' }}
                  ></i>
                </span>
              </div>
            )}
            </div>
            <div
              className={`controls-btn tooltip show-chat-window rightside-settings-icon bottomIcon ${
                chatColor && "pending-chat"
              } ${isActive === "chat" && "current"}`}
              onClick={() => onSelect("chat")}
              id="chatIcon"
            >
              <i className={`icon font-awesome-light-pro va-comment-lines`}></i>
              <span className="tooltiptext">
                {isActive === "chat" ? "Hide Chat" : "View Chat"}
              </span>
            </div>
            {eventType === 1 && role === "Attendee" ? (
              ""
            ) : (
              <div
                className={`controls-btn tooltip show-attendees-list rightside-settings-icon bottomIcon hide-on-mobile ${
                  isActive === "people" && "current"
                }`}
                onClick={() => onSelect("people")}
              >
                <i className={`fa-light fa-users`}></i>
                <span className="tooltiptext">
                  {isActive === "people" ? "Hide Attendees" : "View Attendees"}
                </span>
              </div>
            )}
            <div
              className={`controls-btn tooltip show-setting-window rightside-settings-icon bottomIcon hide-on-mobile ${
                isActive === "settings" && "current"
              }`}
              onClick={() => onSelect("settings")}
            >
              <i className={`icon font-awesome-light-pro va-cog`}></i>
              <span className="tooltiptext">
                {isActive === "settings" ? "Hide Settings" : "View Settings"}
              </span>
            </div>
            <div className="controls-btn show-on-mobile player-action-ellipsis player-action-bar-dot-menu">
              <Dropdown className="">
                <Dropdown.Toggle id="dropdown-basic" className="btn-3dot">
                  <i className="icon font-awesome-normal-pro va-ellipsis-h"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="">
                  <div className="psp-header section-avatar-title-mob dropDownUserInfo">
                    <div className="avatar-box">
                      <Avtar
                        photoUrl={photoHostUrl}
                        userName={userNameHost}
                        people={false}
                      />
                    </div>
                    <div className="avatar-title-box margin-top-0">
                      <h2>{classesName}</h2>
                      <span>{userNameHost}</span>
                    </div>
                  </div>
                  {role === "Presenter" && (
                    <Dropdown.Item
                      id="recordingIconMobile"
                      onClick={() => {
                        handleRecordingClassApp();
                      }}
                    >
                      <i
                        className="icon font-awesome-normal-pro va-record-vinyl"
                        style={{ color: recodingIColor }}
                      ></i>
                      <span id="spanStartRecording">
                        {recodingIColor === "#fff" ? "Record" : ""}
                      </span>
                      <span
                        id="spanStopRecording"
                        className="spanStopRecording"
                      >
                        <span className="innerRecordingWrap">
                          {recodingIColor === "#fff" ? "" : "Recording Stop"}
                          <span
                            id="progressStartTimeInMenu"
                            className="meet-time"
                          >
                            {(recordingAction === 1 ||
                              recordingAction === 3) && (
                              <DigitalWatch
                                isRecording={
                                  recordingAction === 1 || recordingAction === 3
                                }
                              />
                            )}
                          </span>
                        </span>
                      </span>
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => {
                      onSelect("people");
                    }}
                  >
                    <i className="icon fa-light fa-users"></i>
                    Attendees
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setShowGalleryMobile((prev) => !prev);
                    }}
                  >
                    <Dropdown show={showGalleryMobile}>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="btn btn-3dot-icon"
                      >
                        <div className="three-dot-menu">
                          <i className="fa-sharp fa-light fa-gallery-thumbnails icon"></i>
                          Gallery View
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {Object.entries(layoutOptions).map(([key, value]) => (
                          <Dropdown.Item
                            key={key}
                            href="#"
                            active={
                              (layout === value && vertualFocusedContent) ||
                              (layout === value && countRef.current > 0)
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              if (value !== "focusedContent") {
                                setLayout(value);
                                videoGalleryWrapperClassAddAndRemove(value);
                                setExpendVideoTile(false);
                              } else {
                                setLayout(value);
                                countRef.current = countRef.current + 1;
                              }
                            }}
                          >
                            {key}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      onSelect("settings");
                    }}
                  >
                    <i className="icon font-awesome-light-pro va-cog"></i>
                    Settings
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </>
        }
        <button
          type="button"
          className="cbtn thm-btn end-call-btn"
          onClick={() => setExitModalShow(true)}
        >
          <span className="spnEndSession hide-on-mobile">
            {EndCallButtonTextHead()}
          </span>
          <i className="icon font-awesome-solid-pro va-phone-end show-on-mobile"></i>
        </button>
      </div>

      {exitModalShow && (
        <ClassAppointmentExitPopup
          show={exitModalShow}
          onHide={() => setExitModalShow(false)}
          handleEndCall={handleEndCall}
          message={getExitMessage()}
          buttontext={EndCallButtonTextHead()}
          headtext={EndCallButtonTextHead()}
        />
      )}
      {isCameraEnabled && (
        <ClassAppointmentExitPopup
          show={isCameraEnabled}
          onHide={() => setIsCameraEnabled(false)}
          message={getBrowserPermissionSteps("camera")}
         buttontext={"Open Browser Settings"}
          headtext={"Allow Vagaro to Access Camera"}
        />
      )}

      {isMicrophoneEnabled && (
        <ClassAppointmentExitPopup
          show={isMicrophoneEnabled}
          onHide={() => setIsMicrophoneEnabled(false)}
          message={getBrowserPermissionSteps("microphone")}
          buttontext={"Open Browser Settings"}
          headtext={"Allow Vagaro to Access Microphone"}
        />
      )}
    </>
  );
}
export default memo(Navbar);